import { useTranslation } from 'react-i18next'
import { useSpotSwapPair } from '~/state/dex/hooks'
import { useAmountLimits } from '../../hooks'
import NotificationBar from '~/components/NotificationBar'
import { formatAmount } from '../../helpers'

interface Props {
  inputAmount: string
}

const CrossAmountExceedingWarning: React.FC<Props> = ({ inputAmount }) => {
  const { t } = useTranslation()
  const [inputToken] = useSpotSwapPair()
  const {
    isAmountOutOfRange,
    isAmountUnderMin,
    minDeposit,
    maxDeposit,
  } = useAmountLimits(inputAmount)

  if (!isAmountOutOfRange) {
    return null
  }

  const textKey = isAmountUnderMin
    ? 'cross_amount_under_min_warning_content'
    : 'cross_amount_over_max_warning_content'

  const amount = isAmountUnderMin
    ? formatAmount(minDeposit, 6)
    : formatAmount(maxDeposit, 0)

  return (
    <NotificationBar
      level="warning"
      text={t(textKey, {
        amount,
        token: inputToken.symbol,
      })}
      showIcon={false}
      showLink={false}
      showClose={false}
      style={{ marginTop: 16 }}
    />
  )
}

export default CrossAmountExceedingWarning
